import { PresetChartType } from '../const';
import { SubChartType } from '../../../Interface/chart-v3/sdk-model.interface';
import { BaseChartPresetHandler } from './base';
import { BarChartPresetHandler } from './bar';
import { AreaChartPresetHandler } from './area';
import { DoughnutChartPresetHandler } from './doughnut';
import { LineChartPresetHandler } from './line';
import { OfPieChartPresetHandler } from './of-pie';
import { PieChartPresetHandler } from './pie';
import { RadarChartPresetHandler } from './radar';

// 通过图表的子类型（PresetChartType）获取presetHandler
// eslint-disable-next-line complexity
export function getChartPresetHandler(type: PresetChartType): BaseChartPresetHandler | undefined {
    switch (type) {
        case PresetChartType.COLUMN_CLUSTERED:
        case PresetChartType.COLUMN_STACKED:
        case PresetChartType.COLUMN_PERCENT_STACKED:
        case PresetChartType.BAR_CLUSTERED:
        case PresetChartType.BAR_STACKED:
        case PresetChartType.BAR_PERCENT_STACKED:
            return new BarChartPresetHandler();
        case PresetChartType.LINE_STANDARD:
        case PresetChartType.LINE_STACKED:
        case PresetChartType.LINE_PERCENT_STACKED:
        case PresetChartType.LINE_STANDARD_WITH_POINT:
        case PresetChartType.LINE_STACKED_WITH_POINT:
        case PresetChartType.LINE_PERCENT_STACKED_WITH_POINT:
            return new LineChartPresetHandler();
        case PresetChartType.PIE:
            return new PieChartPresetHandler();
        case PresetChartType.OF_PIE:
        case PresetChartType.OF_PIE_BAR:
            return new OfPieChartPresetHandler();
        case PresetChartType.DOUGHNUT:
            return new DoughnutChartPresetHandler();
        case PresetChartType.AREA:
        case PresetChartType.AREA_STACKED:
        case PresetChartType.AREA_PERCENT_STACKED:
            return new AreaChartPresetHandler();
        case PresetChartType.RADAR:
        case PresetChartType.RADAR_WITH_POINT:
        case PresetChartType.RADAR_WITH_FILL:
            return new RadarChartPresetHandler();
    }

    return undefined;
}

// 通过图表的基本类型（ChartType）获取presetHandler
export function getChartPresetHandlerByChartBaseType(type: SubChartType): BaseChartPresetHandler | undefined {
    switch (type) {
        case SubChartType.BarChart:
            return new BarChartPresetHandler();
        case SubChartType.LineChart:
            return new LineChartPresetHandler();
        case SubChartType.RadarChart:
            return new RadarChartPresetHandler();
        case SubChartType.PieChart:
            return new PieChartPresetHandler();
        case SubChartType.DoughnutChart:
            return new DoughnutChartPresetHandler();
        case SubChartType.AreaChart:
            return new AreaChartPresetHandler();
        case SubChartType.OfPieChart:
            return new OfPieChartPresetHandler();
    }

    return undefined;
}
